import { render, staticRenderFns } from "./agentPublishesNotice.vue?vue&type=template&id=71366784&scoped=true"
import script from "./agentPublishesNotice.vue?vue&type=script&lang=js"
export * from "./agentPublishesNotice.vue?vue&type=script&lang=js"
import style0 from "./agentPublishesNotice.vue?vue&type=style&index=0&id=71366784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71366784",
  null
  
)

export default component.exports